import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class AgeticService {
  baseUrl = environment.apiEndpoint + 'agetic/';
  token: string = '';

  constructor(private http: HttpClient) {
   
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken,
      // "access-token": "Bearer " + accessToken,
    });
    return headers;
  }
  
  getDataCpt(cpt: string) {
    
    
  }
 
}
